export default "/kiban/_next/static/images/bottom_orange-2b00282b2246fe7ca4103c758ef732a4.png";